"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUserId = exports.UID_REGEX = void 0;
const utils_1 = require("@hc-frontend/utils");
/**
 * Regular expression used for user id format validation
 *
 * @public
 * @constant
 */
exports.UID_REGEX = /^[A-Z0-9]{28,36}$/;
/**
 * Returns true if the string is a valid user id
 *
 * @public
 * @param {unknown} arg - A generic argument to check
 *
 * @returns {boolean}
 *
 * @example
 * ```ts
 * const result = isValidUserId('21321');
 * console.log(result);
 * // -> true
 * ```
 **/
function isValidUserId(arg) {
    return (0, utils_1.isString)(arg) && exports.UID_REGEX.test(arg);
}
exports.isValidUserId = isValidUserId;
//# sourceMappingURL=is-valid-user-id.js.map